// extracted by mini-css-extract-plugin
export default {"container":"ReviewSection_container__1FlB3"};